import React, { useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft, Globe, CheckCircle, Mail, Send, Download, Sparkles } from 'lucide-react';
import emailjs from "@emailjs/browser";

// MOVED OUTSIDE COMPONENT - This fixes the ESLint error
const questionsData = {
  en: [
    "Worry about things", "Make friends easily", "Have a vivid imagination", "Trust others", "Complete tasks successfully",
    "Get angry easily", "Love large parties", "Believe in the importance of art", "Use others for my own ends", "Like order",
    "Feel comfortable with myself", "Make people feel welcome", "Have a rich vocabulary", "Have a good word for everyone", "Am always prepared",
    "Am easily intimidated", "Talk to a lot of different people at parties", "Can handle a lot of information", "Respect others", "Pay attention to details",
    "Seldom feel blue", "Don't mind being the center of attention", "Love to think up new ways of doing things", "Accept people as they are", "Get chores done right away",
    "Am not easily bothered by things", "Keep in the background", "Do not like art", "Suspect hidden motives in others", "Leave my belongings around",
    "Panic easily", "Don't like to draw attention to myself", "Have difficulty understanding abstract ideas", "Cut others to pieces", "Shirk my duties",
    "Am relaxed most of the time", "Have little to say", "Am not interested in abstract ideas", "Believe that others have good intentions", "Follow a schedule",
    "Often feel blue", "Start conversations", "Love to read challenging material", "Insult people", "Make a mess of things",
    "Am calm in tense situations", "Feel comfortable around people", "Spend time reflecting on things", "Make people feel at ease", "Do things according to a plan"
  ],
  fr: [
    "M'inquiète pour les choses", "Me fais des amis facilement", "Ai une imagination vive", "Fais confiance aux autres", "Termine les tâches avec succès",
    "Me mets en colère facilement", "Aime les grandes fêtes", "Crois en l'importance de l'art", "Utilise les autres pour mes propres fins", "Aime l'ordre",
    "Me sens à l'aise avec moi-même", "Fais en sorte que les gens se sentent les bienvenus", "Ai un vocabulaire riche", "Ai un bon mot pour tout le monde", "Suis toujours préparé",
    "Suis facilement intimidé", "Parle à beaucoup de personnes différentes", "Peux gérer beaucoup d'informations", "Respecte les autres", "Fais attention aux détails",
    "Me sens rarement triste", "Ne crains pas d'être au centre de l'attention", "Aime inventer de nouvelles façons", "Accepte les gens tels qu'ils sont", "Fais les corvées tout de suite",
    "Ne suis pas facilement dérangé", "Reste en arrière-plan", "N'aime pas l'art", "Soupçonne des motifs cachés", "Laisse mes affaires traîner",
    "Panique facilement", "N'aime pas attirer l'attention", "Ai du mal à comprendre les idées abstraites", "Démolit les autres", "Me soustrais à mes devoirs",
    "Suis détendu la plupart du temps", "Ai peu à dire", "Ne suis pas intéressé par les idées abstraites", "Crois que les autres ont de bonnes intentions", "Suis un emploi du temps",
    "Me sens souvent triste", "Commence des conversations", "Aime lire du matériel stimulant", "Insulte les gens", "Fais un gâchis des choses",
    "Suis calme dans les situations tendues", "Me sens à l'aise avec les gens", "Passe du temps à réfléchir", "Mets les gens à l'aise", "Fais les choses selon un plan"
  ],
  de: [
    "Mache mir Sorgen", "Finde leicht Freunde", "Habe lebhafte Vorstellungskraft", "Vertraue anderen", "Erledige Aufgaben erfolgreich",
    "Werde leicht wütend", "Liebe große Partys", "Glaube an Wichtigkeit von Kunst", "Benutze andere", "Mag Ordnung",
    "Fühle mich wohl", "Sorge dafür dass sich Menschen willkommen fühlen", "Habe reichen Wortschatz", "Habe gutes Wort für jeden", "Bin immer vorbereitet",
    "Bin leicht eingeschüchtert", "Spreche mit vielen Leuten", "Kann viele Informationen verarbeiten", "Respektiere andere", "Achte auf Details",
    "Fühle mich selten niedergeschlagen", "Macht mir nichts aus im Mittelpunkt zu stehen", "Liebe es neue Wege zu finden", "Akzeptiere Menschen", "Erledige Aufgaben sofort",
    "Bin nicht leicht gestört", "Bleibe im Hintergrund", "Mag keine Kunst", "Vermute versteckte Motive", "Lasse Sachen herumliegen",
    "Gerate leicht in Panik", "Ziehe es vor nicht im Mittelpunkt zu stehen", "Habe Schwierigkeiten abstrakte Ideen zu verstehen", "Mache andere fertig", "Drücke mich vor Pflichten",
    "Bin meistens entspannt", "Habe wenig zu sagen", "Bin nicht an abstrakten Ideen interessiert", "Glaube dass andere gute Absichten haben", "Folge einem Zeitplan",
    "Fühle mich oft niedergeschlagen", "Beginne Gespräche", "Liebe es herausforderndes Material zu lesen", "Beleidige Menschen", "Mache Durcheinander",
    "Bin ruhig in angespannten Situationen", "Fühle mich wohl mit Menschen", "Verbringe Zeit mit Nachdenken", "Sorge dafür dass sich Menschen wohl fühlen", "Tue Dinge nach Plan"
  ],
  ro: [
    "Îmi fac griji", "Fac prieteni ușor", "Am imaginație vie", "Am încredere în alții", "Finalizez sarcinile cu succes",
    "Mă enervez ușor", "Iubesc petrecerile mari", "Cred în importanța artei", "Folosesc pe alții", "Îmi place ordinea",
    "Mă simt confortabil", "Fac ca oamenii să se simtă bineveți", "Am vocabular bogat", "Am cuvânt bun pentru toată lumea", "Sunt întotdeauna pregătit",
    "Sunt ușor intimidat", "Vorbesc cu mulți oameni", "Pot gestiona multe informații", "Respect pe alții", "Acord atenție detaliilor",
    "Rareori mă simt trist", "Nu-mi pasă să fiu în centrul atenției", "Iubesc să găsesc noi modalități", "Accept oamenii așa cum sunt", "Fac treburile imediat",
    "Nu sunt ușor deranjat", "Rămân în fundal", "Nu-mi place arta", "Bănuiesc motive ascunse", "Îmi las lucrurile împrăștiate",
    "Intru în panică ușor", "Nu-mi place să atrag atenția", "Am dificultăți să înțeleg idei abstracte", "Demolez pe alții", "Mă sustrag de la îndatoriri",
    "Sunt relaxat majoritatea timpului", "Am puțin de spus", "Nu sunt interesat de idei abstracte", "Cred că alții au intenții bune", "Urmez un program",
    "Mă simt adesea trist", "Încep conversații", "Iubesc să citesc material provocator", "Insult oamenii", "Fac dezordine",
    "Sunt calm în situații tensionate", "Mă simt confortabil cu oamenii", "Petrec timp reflectând", "Fac ca oamenii să se simtă confortabil", "Fac lucrurile după un plan"
  ]
};

// MOVED OUTSIDE COMPONENT - This fixes the ESLint error
const domains = ["N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C", "N", "E", "O", "A", "C"];

const CareerInsightTool = () => {
  const [language, setLanguage] = useState('en');
  const [currentStep, setCurrentStep] = useState('intro');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [testQuestions, setTestQuestions] = useState([]);
  const [results, setResults] = useState(null);
  const [aiInsights, setAiInsights] = useState(null);
  const [loadingAI, setLoadingAI] = useState(false);
  const [email, setEmail] = useState('');
  const [newsletter, setNewsletter] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [emailError, setEmailError] = useState('');

  const translations = {
    en: {
      title: "Career Insight Tool",
      subtitle: "Discover Your Strengths & Career Path",
      intro: {
        heading: "Welcome to Your Career Discovery Journey",
        description: "This scientifically-validated Big Five personality assessment will help you understand your core strengths, values, and career alignment. Perfect for mid-career professionals and career changers.",
        howItWorks: "How It Works:",
        steps: [
          "Complete the 50-question personality assessment (5-7 minutes)",
          "Receive your personalized personality profile",
          "Discover your core strengths and transferable skills",
          "Get AI-powered career development recommendations",
          "Adapt your career summary for job applications"
        ],
        privacy: "Your privacy matters: All responses are anonymous and stored only in your browser session. No data is saved permanently.",
        startButton: "Start Your Assessment"
      },
      test: {
        question: "Question",
        of: "of",
        progress: "Progress",
        previous: "Previous",
        next: "Next",
        finish: "Finish"
      },
      results: {
        title: "Your Personality Profile",
        subtitle: "Based on the Big Five personality assessment",
        generating: "Generating your personalized career insights...",
        strengths: "Your Core Strengths",
        skills: "Transferable Skills",
        values: "Personal Values",
        recommendations: "Career Development Recommendations",
        careerSummary: "AI-Generated Career Summary",
        emailTitle: "Email Your Results",
        emailPlaceholder: "Enter your email address",
        newsletterLabel: "Subscribe to hrtCareer newsletter for career tips and insights",
        sendButton: "Send Results",
        emailSuccess: "Results sent successfully!",
        emailError: "Failed to send email. Please try again.",
        downloadButton: "Download Report",
        retakeButton: "Take Test Again",
        privacyNote: "Note: Your results will not be stored. They will only be sent to your email."
      },
      selectLanguage: "Select Language",
      domains: {
        N: "Neuroticism",
        E: "Extraversion",
        O: "Openness",
        A: "Agreeableness",
        C: "Conscientiousness"
      },
      choices: [
        "Very Inaccurate",
        "Moderately Inaccurate",
        "Neither Accurate Nor Inaccurate",
        "Moderately Accurate",
        "Very Accurate"
      ]
    },
    fr: {
      title: "Outil d'Orientation Professionnelle",
      subtitle: "Découvrez Vos Forces & Votre Parcours Professionnel",
      intro: {
        heading: "Bienvenue dans Votre Parcours de Découverte Professionnelle",
        description: "Cette évaluation de personnalité Big Five scientifiquement validée vous aidera à comprendre vos forces fondamentales, vos valeurs et votre alignement professionnel.",
        howItWorks: "Comment ça Fonctionne:",
        steps: [
          "Complétez l'évaluation de 50 questions (5-7 minutes)",
          "Recevez votre profil de personnalité personnalisé",
          "Découvrez vos forces principales et compétences transférables",
          "Obtenez des recommandations de carrière basées sur l'IA",
          "Adaptez votre résumé de carrière pour les candidatures"
        ],
        privacy: "Votre vie privée compte: Toutes les réponses sont anonymes et stockées uniquement dans votre session de navigateur.",
        startButton: "Commencer Votre Évaluation"
      },
      test: {
        question: "Question",
        of: "de",
        progress: "Progression",
        previous: "Précédent",
        next: "Suivant",
        finish: "Terminer"
      },
      results: {
        title: "Votre Profil de Personnalité",
        subtitle: "Basé sur l'évaluation Big Five",
        generating: "Génération de vos perspectives de carrière personnalisées...",
        strengths: "Vos Forces Principales",
        skills: "Compétences Transférables",
        values: "Valeurs Personnelles",
        recommendations: "Recommandations de Développement de Carrière",
        careerSummary: "Résumé de Carrière Généré par IA",
        emailTitle: "Envoyer Vos Résultats par Email",
        emailPlaceholder: "Entrez votre adresse email",
        newsletterLabel: "S'abonner à la newsletter hrtCareer",
        sendButton: "Envoyer les Résultats",
        emailSuccess: "Résultats envoyés avec succès!",
        emailError: "Échec de l'envoi. Veuillez réessayer.",
        downloadButton: "Télécharger le Rapport",
        retakeButton: "Refaire le Test",
        privacyNote: "Note: Vos résultats ne seront pas stockés."
      },
      selectLanguage: "Choisir la Langue",
      domains: {
        N: "Névrosisme",
        E: "Extraversion",
        O: "Ouverture",
        A: "Agréabilité",
        C: "Conscience"
      },
      choices: [
        "Très Inexact",
        "Modérément Inexact",
        "Ni Exact Ni Inexact",
        "Modérément Exact",
        "Très Exact"
      ]
    },
    de: {
      title: "Karriere-Orientierungs-Tool",
      subtitle: "Entdecken Sie Ihre Stärken & Karriereweg",
      intro: {
        heading: "Willkommen zu Ihrer Beruflichen Entdeckungsreise",
        description: "Diese wissenschaftlich validierte Big Five Persönlichkeitsbewertung hilft Ihnen, Ihre Kernstärken zu verstehen.",
        howItWorks: "Wie es Funktioniert:",
        steps: [
          "Absolvieren Sie die 50-Fragen-Bewertung (5-7 Minuten)",
          "Erhalten Sie Ihr personalisiertes Persönlichkeitsprofil",
          "Entdecken Sie Ihre Kernstärken",
          "Erhalten Sie KI-gestützte Karriereempfehlungen",
          "Passen Sie Ihre Karrierezusammenfassung an"
        ],
        privacy: "Ihre Privatsphäre ist wichtig: Alle Antworten sind anonym.",
        startButton: "Beginnen Sie Ihre Bewertung"
      },
      test: {
        question: "Frage",
        of: "von",
        progress: "Fortschritt",
        previous: "Zurück",
        next: "Weiter",
        finish: "Fertig"
      },
      results: {
        title: "Ihr Persönlichkeitsprofil",
        subtitle: "Basierend auf der Big Five Bewertung",
        generating: "Ihre Karriere-Einblicke werden generiert...",
        strengths: "Ihre Kernstärken",
        skills: "Übertragbare Fähigkeiten",
        values: "Persönliche Werte",
        recommendations: "Karriereentwicklungsempfehlungen",
        careerSummary: "KI-Generierte Karrierezusammenfassung",
        emailTitle: "Ergebnisse per E-Mail",
        emailPlaceholder: "E-Mail-Adresse eingeben",
        newsletterLabel: "hrtCareer-Newsletter abonnieren",
        sendButton: "Ergebnisse Senden",
        emailSuccess: "Ergebnisse erfolgreich gesendet!",
        emailError: "Senden fehlgeschlagen.",
        downloadButton: "Bericht Herunterladen",
        retakeButton: "Test Wiederholen",
        privacyNote: "Hinweis: Ihre Ergebnisse werden nicht gespeichert."
      },
      selectLanguage: "Sprache Wählen",
      domains: {
        N: "Neurotizismus",
        E: "Extraversion",
        O: "Offenheit",
        A: "Verträglichkeit",
        C: "Gewissenhaftigkeit"
      },
      choices: [
        "Sehr Ungenau",
        "Mäßig Ungenau",
        "Weder Genau Noch Ungenau",
        "Mäßig Genau",
        "Sehr Genau"
      ]
    },
    ro: {
      title: "Instrument de Orientare în Carieră",
      subtitle: "Descoperă-ți Punctele Forte & Calea Profesională",
      intro: {
        heading: "Bun Venit în Călătoria Ta de Descoperire Profesională",
        description: "Această evaluare Big Five te va ajuta să înțelegi punctele tale forte fundamentale.",
        howItWorks: "Cum Funcționează:",
        steps: [
          "Completează evaluarea de 50 întrebări (5-7 minute)",
          "Primești profilul tău personalizat",
          "Descoperă punctele tale forte",
          "Primește recomandări bazate pe AI",
          "Adaptează-ți rezumatul de carieră"
        ],
        privacy: "Confidențialitatea ta contează: Răspunsurile sunt anonime.",
        startButton: "Începe Evaluarea"
      },
      test: {
        question: "Întrebarea",
        of: "din",
        progress: "Progres",
        previous: "Anterior",
        next: "Următorul",
        finish: "Finalizează"
      },
      results: {
        title: "Profilul Tău de Personalitate",
        subtitle: "Bazat pe evaluarea Big Five",
        generating: "Se generează perspectivele tale de carieră...",
        strengths: "Punctele Tale Forte",
        skills: "Abilități Transferabile",
        values: "Valori Personale",
        recommendations: "Recomandări de Dezvoltare",
        careerSummary: "Rezumat de Carieră Generat de AI",
        emailTitle: "Trimite Rezultatele",
        emailPlaceholder: "Adresa ta de email",
        newsletterLabel: "Abonează-te la newsletter-ul hrtCareer",
        sendButton: "Trimite Rezultatele",
        emailSuccess: "Rezultate trimise cu succes!",
        emailError: "Trimitere eșuată.",
        downloadButton: "Descarcă Raportul",
        retakeButton: "Reia Testul",
        privacyNote: "Notă: Rezultatele nu vor fi stocate."
      },
      selectLanguage: "Selectează Limba",
      domains: {
        N: "Neuroticismul",
        E: "Extraversiunea",
        O: "Deschiderea",
        A: "Agreabilitatea",
        C: "Conștiinciozitatea"
      },
      choices: [
        "Foarte Inexact",
        "Moderat Inexact",
        "Nici Exact Nici Inexact",
        "Moderat Exact",
        "Foarte Exact"
      ]
    }
  };
   

const t = translations[language];

//Now the useEffect won't trigger unnecessarily because questionsData and domains are stable
  useEffect(() => {
    const questions = questionsData[language].map((text, index) => ({
      id: index + 1,
      text: text,
      domain: domains[index],
      facet: (index % 5) + 1
    }));
    setTestQuestions(questions);
  }, [language]); 

//Removed questionsData and domains from dependencies
//rest of your component code remains the same

  const handleAnswer = (score) => {
    const newAnswers = {
      ...answers,
      [currentQuestion]: {
        questionIndex: currentQuestion,
        domain: testQuestions[currentQuestion].domain,
        facet: testQuestions[currentQuestion].facet,
        score
      }
    };
    setAnswers(newAnswers);
  };

  const handleNext = () => {
    if (currentQuestion < testQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      calculateResults();
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const calculateResults = async () => {
    const domainScores = { N: [], E: [], O: [], A: [], C: [] };
    
    Object.values(answers).forEach(answer => {
      if (domainScores[answer.domain]) {
        domainScores[answer.domain].push(answer.score);
      }
    });

    const finalScores = {};
    Object.keys(domainScores).forEach(domain => {
      const scores = domainScores[domain];
      const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
      finalScores[domain] = Math.round((avg / 5) * 100);
    });

    setResults(finalScores);
    setCurrentStep('results');
    
    await generateAIInsights(finalScores);
  };

  const generateAIInsights = async (scores) => {
    setLoadingAI(true);
    
    // Simulate processing time for better UX
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Generate personality-based insights using Big Five scores
    const insights = generatePersonalityInsights(scores, language);
    
    setAiInsights(insights);
    setLoadingAI(false);
  };

  const generatePersonalityInsights = (scores, lang) => {
    // Determine dominant traits
    const highO = scores.O >= 60;
    const highC = scores.C >= 60;
    const highE = scores.E >= 60;
    const highA = scores.A >= 60;
    const lowN = scores.N <= 40;

    const insights = {
      en: {
        strengths: [],
        skills: [],
        values: [],
        recommendations: [],
        careerSummary: ""
      },
      fr: {
        strengths: [],
        skills: [],
        values: [],
        recommendations: [],
        careerSummary: ""
      },
      de: {
        strengths: [],
        skills: [],
        values: [],
        recommendations: [],
        careerSummary: ""
      },
      ro: {
        strengths: [],
        skills: [],
        values: [],
        recommendations: [],
        careerSummary: ""
      }
    };

    // Generate strengths based on personality profile
    if (highO) {
      insights.en.strengths.push("Creative problem-solving", "Innovative thinking", "Adaptability to change");
      insights.fr.strengths.push("Résolution créative de problèmes", "Pensée innovante", "Adaptabilité au changement");
      insights.de.strengths.push("Kreative Problemlösung", "Innovatives Denken", "Anpassungsfähigkeit an Veränderungen");
      insights.ro.strengths.push("Rezolvarea creativă a problemelor", "Gândire inovatoare", "Adaptabilitate la schimbare");
    } else {
      insights.en.strengths.push("Practical problem-solving", "Focus on proven methods", "Consistency");
      insights.fr.strengths.push("Résolution pratique de problèmes", "Focus sur méthodes éprouvées", "Cohérence");
      insights.de.strengths.push("Praktische Problemlösung", "Fokus auf bewährte Methoden", "Beständigkeit");
      insights.ro.strengths.push("Rezolvarea practică a problemelor", "Concentrare pe metode dovedite", "Consistență");
    }

    if (highC) {
      insights.en.strengths.push("Strong organizational skills", "Attention to detail", "Reliability");
      insights.fr.strengths.push("Fortes compétences organisationnelles", "Attention aux détails", "Fiabilité");
      insights.de.strengths.push("Starke Organisationsfähigkeiten", "Detailgenauigkeit", "Zuverlässigkeit");
      insights.ro.strengths.push("Abilități organizaționale puternice", "Atenție la detalii", "Fiabilitate");
    } else {
      insights.en.strengths.push("Flexibility", "Spontaneity", "Adaptable approach");
      insights.fr.strengths.push("Flexibilité", "Spontanéité", "Approche adaptable");
      insights.de.strengths.push("Flexibilität", "Spontaneität", "Anpassungsfähiger Ansatz");
      insights.ro.strengths.push("Flexibilitate", "Spontaneitate", "Abordare adaptabilă");
    }

    if (highE) {
      insights.en.strengths.push("Strong communication", "Team collaboration", "Networking ability");
      insights.fr.strengths.push("Communication forte", "Collaboration d'équipe", "Capacité de réseautage");
      insights.de.strengths.push("Starke Kommunikation", "Teamzusammenarbeit", "Netzwerkfähigkeit");
      insights.ro.strengths.push("Comunicare puternică", "Colaborare în echipă", "Abilitate de networking");
    } else {
      insights.en.strengths.push("Independent work", "Deep focus", "Analytical thinking");
      insights.fr.strengths.push("Travail indépendant", "Concentration profonde", "Pensée analytique");
      insights.de.strengths.push("Selbstständiges Arbeiten", "Tiefe Konzentration", "Analytisches Denken");
      insights.ro.strengths.push("Muncă independentă", "Concentrare profundă", "Gândire analitică");
    }

    // Generate skills
    const skillSets = {
      en: highE ? 
        ["Leadership", "Public speaking", "Team management", "Stakeholder engagement", "Negotiation"] :
        ["Project management", "Research and analysis", "Strategic planning", "Technical expertise", "Quality assurance"],
      fr: highE ?
        ["Leadership", "Prise de parole en public", "Gestion d'équipe", "Engagement des parties prenantes", "Négociation"] :
        ["Gestion de projet", "Recherche et analyse", "Planification stratégique", "Expertise technique", "Assurance qualité"],
      de: highE ?
        ["Führung", "Öffentliches Sprechen", "Teammanagement", "Stakeholder-Engagement", "Verhandlung"] :
        ["Projektmanagement", "Forschung und Analyse", "Strategische Planung", "Technisches Fachwissen", "Qualitätssicherung"],
      ro: highE ?
        ["Leadership", "Vorbire în public", "Managementul echipei", "Implicarea părților interesate", "Negociere"] :
        ["Management de proiect", "Cercetare și analiză", "Planificare strategică", "Expertiză tehnică", "Asigurarea calității"]
    };

    insights.en.skills = skillSets.en;
    insights.fr.skills = skillSets.fr;
    insights.de.skills = skillSets.de;
    insights.ro.skills = skillSets.ro;

    // Generate values
    if (highA) {
      insights.en.values.push("Collaboration", "Integrity", "Empathy");
      insights.fr.values.push("Collaboration", "Intégrité", "Empathie");
      insights.de.values.push("Zusammenarbeit", "Integrität", "Empathie");
      insights.ro.values.push("Colaborare", "Integritate", "Empatie");
    } else {
      insights.en.values.push("Results-focus", "Objectivity", "Efficiency");
      insights.fr.values.push("Focus sur les résultats", "Objectivité", "Efficacité");
      insights.de.values.push("Ergebnisorientierung", "Objektivität", "Effizienz");
      insights.ro.values.push("Concentrare pe rezultate", "Obiectivitate", "Eficiență");
    }

    if (highO) {
      insights.en.values.push("Innovation", "Growth", "Learning");
      insights.fr.values.push("Innovation", "Croissance", "Apprentissage");
      insights.de.values.push("Innovation", "Wachstum", "Lernen");
      insights.ro.values.push("Inovație", "Creștere", "Învățare");
    } else {
      insights.en.values.push("Stability", "Tradition", "Reliability");
      insights.fr.values.push("Stabilité", "Tradition", "Fiabilité");
      insights.de.values.push("Stabilität", "Tradition", "Zuverlässigkeit");
      insights.ro.values.push("Stabilitate", "Tradiție", "Fiabilitate");
    }

    // Generate recommendations
    if (highC && highE) {
      insights.en.recommendations.push(
        "Consider leadership roles that combine organization with team management",
        "Develop your strategic planning skills through formal training",
        "Seek opportunities to mentor and coach others"
      );
      insights.fr.recommendations.push(
        "Envisagez des rôles de leadership combinant organisation et gestion d'équipe",
        "Développez vos compétences en planification stratégique",
        "Cherchez des opportunités de mentorat"
      );
      insights.de.recommendations.push(
        "Erwägen Sie Führungsrollen, die Organisation mit Teammanagement verbinden",
        "Entwickeln Sie Ihre strategischen Planungsfähigkeiten",
        "Suchen Sie Mentoring-Möglichkeiten"
      );
      insights.ro.recommendations.push(
        "Luați în considerare roluri de leadership care combină organizarea cu managementul echipei",
        "Dezvoltați abilitățile de planificare strategică",
        "Căutați oportunități de mentorat"
      );
    } else if (highO && !highE) {
      insights.en.recommendations.push(
        "Explore roles in research, innovation, or creative problem-solving",
        "Build expertise in emerging technologies or methodologies",
        "Consider independent consulting or specialist positions"
      );
      insights.fr.recommendations.push(
        "Explorez des rôles en recherche, innovation ou résolution créative",
        "Développez une expertise dans les technologies émergentes",
        "Envisagez le conseil indépendant ou des postes de spécialiste"
      );
      insights.de.recommendations.push(
        "Erkunden Sie Rollen in Forschung, Innovation oder kreativer Problemlösung",
        "Bauen Sie Expertise in neuen Technologien auf",
        "Erwägen Sie unabhängige Beratung oder Spezialistenpositionen"
      );
      insights.ro.recommendations.push(
        "Explorați roluri în cercetare, inovație sau rezolvarea creativă a problemelor",
        "Construiți expertiză în tehnologii emergente",
        "Luați în considerare consultanță independentă"
      );
    } else {
      insights.en.recommendations.push(
        "Focus on building both technical and interpersonal skills",
        "Seek cross-functional projects to broaden your experience",
        "Consider professional certifications in your field"
      );
      insights.fr.recommendations.push(
        "Concentrez-vous sur le développement de compétences techniques et interpersonnelles",
        "Cherchez des projets transversaux pour élargir votre expérience",
        "Envisagez des certifications professionnelles"
      );
      insights.de.recommendations.push(
        "Konzentrieren Sie sich auf den Aufbau technischer und zwischenmenschlicher Fähigkeiten",
        "Suchen Sie funktionsübergreifende Projekte",
        "Erwägen Sie professionelle Zertifizierungen"
      );
      insights.ro.recommendations.push(
        "Concentrați-vă pe construirea abilităților tehnice și interpersonale",
        "Căutați proiecte interfuncționale",
        "Luați în considerare certificări profesionale"
      );
    }

    // Generate career summary
    const summaries = {
      en: `A ${highC ? 'organized and reliable' : 'flexible and adaptable'} professional with ${highE ? 'strong interpersonal and leadership' : 'excellent analytical and independent work'} capabilities. Demonstrates ${highO ? 'innovative thinking and openness to new approaches' : 'practical problem-solving and focus on proven methods'}, combined with ${highA ? 'collaborative teamwork and empathy' : 'results-driven focus and objectivity'}. ${lowN ? 'Maintains composure under pressure and handles challenges with confidence.' : 'Brings emotional depth and thoughtful consideration to decision-making.'} Well-suited for roles requiring ${highC && highE ? 'strategic leadership and organizational excellence' : highO ? 'creative problem-solving and innovation' : 'reliable execution and quality delivery'}.`,
      fr: `Un professionnel ${highC ? 'organisé et fiable' : 'flexible et adaptable'} avec des capacités ${highE ? 'interpersonnelles et de leadership solides' : 'd\'analyse excellentes et de travail indépendant'}. Démontre ${highO ? 'une pensée innovante et une ouverture aux nouvelles approches' : 'une résolution pratique de problèmes et un focus sur les méthodes éprouvées'}, combiné avec ${highA ? 'un travail d\'équipe collaboratif et de l\'empathie' : 'un focus axé sur les résultats et l\'objectivité'}. ${lowN ? 'Maintient son sang-froid sous pression.' : 'Apporte une profondeur émotionnelle à la prise de décision.'} Bien adapté pour des rôles nécessitant ${highC && highE ? 'leadership stratégique et excellence organisationnelle' : highO ? 'résolution créative de problèmes et innovation' : 'exécution fiable et livraison de qualité'}.`,
      de: `Ein ${highC ? 'organisierter und zuverlässiger' : 'flexibler und anpassungsfähiger'} Fachmann mit ${highE ? 'starken zwischenmenschlichen und Führungs' : 'ausgezeichneten analytischen und unabhängigen Arbeits'}fähigkeiten. Zeigt ${highO ? 'innovatives Denken und Offenheit für neue Ansätze' : 'praktische Problemlösung und Fokus auf bewährte Methoden'}, kombiniert mit ${highA ? 'kollaborativer Teamarbeit und Empathie' : 'ergebnisorientiertem Fokus und Objektivität'}. ${lowN ? 'Behält die Fassung unter Druck.' : 'Bringt emotionale Tiefe in die Entscheidungsfindung.'} Gut geeignet für Rollen, die ${highC && highE ? 'strategische Führung und organisatorische Exzellenz' : highO ? 'kreative Problemlösung und Innovation' : 'zuverlässige Ausführung und Qualitätslieferung'} erfordern.`,
      ro: `Un profesionist ${highC ? 'organizat și fiabil' : 'flexibil și adaptabil'} cu capacități ${highE ? 'interpersonale și de leadership puternice' : 'analitice excelente și de lucru independent'}. Demonstrează ${highO ? 'gândire inovatoare și deschidere către noi abordări' : 'rezolvarea practică a problemelor și concentrare pe metode dovedite'}, combinat cu ${highA ? 'munca în echipă colaborativă și empatie' : 'concentrare pe rezultate și obiectivitate'}. ${lowN ? 'Menține calmul sub presiune.' : 'Aduce profunzime emoțională în luarea deciziilor.'} Potrivit pentru roluri care necesită ${highC && highE ? 'leadership strategic și excelență organizațională' : highO ? 'rezolvarea creativă a problemelor și inovație' : 'execuție fiabilă și livrare de calitate'}.`
    };

    insights.en.careerSummary = summaries.en;
    insights.fr.careerSummary = summaries.fr;
    insights.de.careerSummary = summaries.de;
    insights.ro.careerSummary = summaries.ro;

    return insights[lang];
  };

  const handleEmailResults = async () => { 
  if (!email) return;

  setEmailError('');
  setEmailSent(false);

  try {
    // EmailJS Configuration - Replace with your actual IDs
    const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    

    const templateParams = {
      email: email,
      user_name: email.split('@')[0],
      language: language,
      openness_score: results.O,
      conscientiousness_score: results.C,
      extraversion_score: results.E,
      agreeableness_score: results.A,
      neuroticism_score: results.N,
      strengths: aiInsights?.strengths.join(', ') || '',
      skills: aiInsights?.skills.join(', ') || '',
      values: aiInsights?.values.join(', ') || '',
      recommendations: aiInsights?.recommendations.join('\n') || '',
      career_summary: aiInsights?.careerSummary || '',
      newsletter_signup: newsletter ? 'Yes' : 'No',
      openness_label: t.domains.O,
      conscientiousness_label: t.domains.C,
      extraversion_label: t.domains.E,
      agreeableness_label: t.domains.A,
      neuroticism_label: t.domains.N
    };

    //Send email using EmailJS
    const result = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );

    console.log("✅ Email sent!", result.text);

    if (newsletter) {
      console.log("Newsletter subscription:", email);
      

    }

    setEmailSent(true);
    setTimeout(() => setEmailSent(false), 5000);

  } catch (error) {
    console.error("❌ EmailJS error:", error);
    setEmailError(t.results.emailError);
  }
};
  
  const LanguageSelector = () => (
    <div className="flex items-center gap-2 mb-6">
      <Globe className="w-5 h-5 text-teal-600" />
      <select
        value={language}
        onChange={(e) => {
          setLanguage(e.target.value);
          setCurrentStep('intro');
          setCurrentQuestion(0);
          setAnswers({});
        }}
        className="px-4 py-2 bg-white border-2 border-gray-200 rounded-lg focus:border-teal-500 focus:outline-none text-gray-700 font-medium"
      >
        <option value="en">English</option>
        <option value="fr">Français</option>
        <option value="de">Deutsch</option>
        <option value="ro">Română</option>
      </select>
    </div>
  );

  if (currentStep === 'intro') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-emerald-50 py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <LanguageSelector />
          
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-t-4 border-teal-500">
            <div className="text-center mb-8">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
                {t.title}
              </h1>
              <p className="text-xl text-teal-600 font-semibold">
                {t.subtitle}
              </p>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t.intro.heading}
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                {t.intro.description}
              </p>
            </div>

            <div className="bg-teal-50 rounded-xl p-6 mb-8 border-l-4 border-teal-500">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <CheckCircle className="w-6 h-6 text-teal-600" />
                {t.intro.howItWorks}
              </h3>
              <ol className="space-y-3">
                {t.intro.steps.map((step, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                      {index + 1}
                    </span>
                    <span className="text-gray-700 pt-1">{step}</span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="bg-emerald-50 border-l-4 border-emerald-500 rounded-lg p-4 mb-8">
              <p className="text-gray-700">🔒 {t.intro.privacy}</p>
            </div>

            <button
              onClick={() => setCurrentStep('test')}
              className="w-full bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white font-bold py-4 px-8 rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg hover:shadow-xl"
            >
              {t.intro.startButton}
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>

          <div className="text-center mt-8 text-sm text-gray-600">
            <p>Powered by <a href="https://www.hrtcareer.com" target="_blank" rel="noopener noreferrer" className="text-teal-600 font-semibold hover:underline">hrtCareer.com</a></p>
          </div>
        </div>
      </div>
    );
  }

  if (currentStep === 'test') {
    if (testQuestions.length === 0) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-emerald-50 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading questions...</p>
          </div>
        </div>
      );
    }

    const progress = ((currentQuestion + 1) / testQuestions.length) * 100;
    const currentQ = testQuestions[currentQuestion];
    const isAnswered = answers[currentQuestion] !== undefined;
    const isLastQuestion = currentQuestion === testQuestions.length - 1;

    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-emerald-50 py-12 px-4">
        <div className="max-w-3xl mx-auto">
          <LanguageSelector />
          
          <div className="bg-white rounded-2xl shadow-xl p-8 border-t-4 border-teal-500">
            <div className="mb-6">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-600">
                  {t.test.progress}
                </span>
                <span className="text-sm font-bold text-teal-600">
                  {currentQuestion + 1} {t.test.of} {testQuestions.length}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className="bg-gradient-to-r from-teal-600 to-emerald-600 h-3 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8">
                {currentQ.text}
              </h2>

              <div className="space-y-3">
                {t.choices.map((choice, index) => {
                  const score = index + 1;
                  const isSelected = answers[currentQuestion]?.score === score;
                  return (
                    <button
                      key={index}
                      onClick={() => handleAnswer(score)}
                      className={`w-full text-left px-6 py-4 border-2 rounded-xl transition-all font-medium ${
                        isSelected
                          ? 'bg-teal-100 border-teal-500 text-teal-700'
                          : 'bg-gray-50 hover:bg-teal-50 border-gray-200 hover:border-teal-500 text-gray-700 hover:text-teal-700'
                      }`}
                    >
                      {choice}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="flex gap-4">
              <button
                onClick={handlePrevious}
                disabled={currentQuestion === 0}
                className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed font-semibold transition-all"
              >
                <ChevronLeft className="w-5 h-5" />
                {t.test.previous}
              </button>
              
              <button
                onClick={handleNext}
                disabled={!isAnswered}
                className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed font-semibold transition-all"
              >
                {isLastQuestion ? t.test.finish : t.test.next}
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (currentStep === 'results') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-emerald-50 py-12 px-4">
        <div className="max-w-5xl mx-auto">
          <LanguageSelector />
          
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-t-4 border-teal-500">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-gray-900 mb-3">
                {t.results.title}
              </h1>
              <p className="text-lg text-gray-600">
                {t.results.subtitle}
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Big Five Scores</h2>
              <div className="space-y-4">
                {Object.entries(results).map(([domain, score]) => (
                  <div key={domain} className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl p-6 border-l-4 border-teal-500">
                    <div className="flex justify-between items-center mb-3">
                      <h3 className="text-lg font-bold text-gray-900">
                        {t.domains[domain]}
                      </h3>
                      <span className="text-2xl font-bold text-teal-600">
                        {score}%
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-3">
                      <div
                        className="bg-gradient-to-r from-teal-600 to-emerald-600 h-3 rounded-full transition-all"
                        style={{ width: `${score}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {loadingAI && (
              <div className="text-center py-12">
                <Sparkles className="w-12 h-12 text-teal-600 animate-pulse mx-auto mb-4" />
                <p className="text-lg text-gray-600">{t.results.generating}</p>
              </div>
            )}

            {aiInsights && !loadingAI && (
              <div className="space-y-8 mb-12">
                <div className="bg-white border-2 border-teal-200 rounded-xl p-6">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <CheckCircle className="w-6 h-6 text-teal-600" />
                    {t.results.strengths}
                  </h2>
                  <ul className="space-y-2">
                    {aiInsights.strengths.map((strength, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <span className="text-teal-600 mt-1">•</span>
                        <span className="text-gray-700">{strength}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white border-2 border-emerald-200 rounded-xl p-6">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    {t.results.skills}
                  </h2>
                  <div className="flex flex-wrap gap-2">
                    {aiInsights.skills.map((skill, index) => (
                      <span key={index} className="px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full font-medium">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="bg-white border-2 border-teal-200 rounded-xl p-6">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    {t.results.values}
                  </h2>
                  <div className="flex flex-wrap gap-2">
                    {aiInsights.values.map((value, index) => (
                      <span key={index} className="px-4 py-2 bg-teal-100 text-teal-700 rounded-full font-medium">
                        {value}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-r from-teal-50 to-emerald-50 border-2 border-teal-300 rounded-xl p-6">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    {t.results.recommendations}
                  </h2>
                  <ol className="space-y-3">
                    {aiInsights.recommendations.map((rec, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <span className="flex-shrink-0 w-6 h-6 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                          {index + 1}
                        </span>
                        <span className="text-gray-700 pt-0.5">{rec}</span>
                      </li>
                    ))}
                  </ol>
                </div>

                <div className="bg-white border-2 border-emerald-200 rounded-xl p-6">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Sparkles className="w-6 h-6 text-emerald-600" />
                    {t.results.careerSummary}
                  </h2>
                  <p className="text-gray-700 leading-relaxed text-lg">
                    {aiInsights.careerSummary}
                  </p>
                </div>
              </div>
            )}

            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl p-8 border-2 border-teal-300 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <Mail className="w-6 h-6 text-teal-600" />
                {t.results.emailTitle}
              </h2>
              
              <p className="text-sm text-gray-600 mb-4">
                {t.results.privacyNote}
              </p>

              <div className="space-y-4">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t.results.emailPlaceholder}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none"
                />

                <div className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    id="newsletter"
                    checked={newsletter}
                    onChange={(e) => setNewsletter(e.target.checked)}
                    className="mt-1 w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                  />
                  <label htmlFor="newsletter" className="text-sm text-gray-700">
                    {t.results.newsletterLabel}
                  </label>
                </div>

                <button
                  onClick={handleEmailResults}
                  disabled={!email}
                  className="w-full bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 transition-all disabled:cursor-not-allowed"
                >
                  <Send className="w-5 h-5" />
                  {t.results.sendButton}
                </button>

                {emailSent && (
                  <div className="bg-green-100 border-2 border-green-500 text-green-700 px-4 py-3 rounded-lg text-center font-semibold">
                    ✓ {t.results.emailSuccess}
                  </div>
                )}

                {emailError && (
                  <div className="bg-red-100 border-2 border-red-500 text-red-700 px-4 py-3 rounded-lg text-center font-semibold">
                    {emailError}
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => {
                  setCurrentStep('intro');
                  setCurrentQuestion(0);
                  setAnswers({});
                  setResults(null);
                  setAiInsights(null);
                  setEmail('');
                  setNewsletter(false);
                }}
                className="flex-1 bg-white border-2 border-teal-600 text-teal-600 hover:bg-teal-50 font-bold py-3 px-6 rounded-lg transition-all"
              >
                {t.results.retakeButton}
              </button>
              
              <button
                onClick={() => window.print()}
                className="flex-1 bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 transition-all"
              >
                <Download className="w-5 h-5" />
                {t.results.downloadButton}
              </button>
            </div>
          </div>

          <div className="text-center mt-8 text-sm text-gray-600">
            <p>Powered by <a href="https://www.hrtcareer.com" target="_blank" rel="noopener noreferrer" className="text-teal-600 font-semibold hover:underline">hrtCareer.com</a></p>
          </div>
        </div>
      </div>
    );
  }
};

export default CareerInsightTool;